const online_config = {
  h5_login:'//m.mgtv.com/login/',
  api_user_info: "//vipact3.api.mgtv.com/api/v1/act/viptype",
  api_vip_info: "//as.mgtv.com/client/user/user_info",
  api_user_groups_check: "//as.mgtv.com/client/user/user_groups_check",
  api_act_stat: "",
  api_vote_list: "//vipact.api.mgtv.com/mapi/act/bet/list",
  api_vote_vote: "//vipact.api.mgtv.com/mapi/act/bet/bet",
  api_vote_award: "//vipact.api.mgtv.com/mapi/act/bet/award",
  api_act_uinfo_add: "//vipact.api.mgtv.com/mapi/act/uinfo/add",
  api_act_uinfo_get: "//vipact.api.mgtv.com/mapi/act/uinfo/get",
  api_logout:"//nuc.api.mgtv.com/Logout",
  create_vip_order: "//as.mgtv.com/client/order/orderBuy",
  wx_share:'https://club.api.mgtv.com/usercenter/v2/mangoLogin/js',
  h5_cashier:"https://club.mgtv.com/act/mgtv_cashier/index.html",
  moreBenefitUrl: 'https://club.mgtv.com/act/vipbenefit_2019.html'
}

const test_config = Object.assign({}, online_config, {

})


export default {
  online_env: online_config,
  test_env: test_config
}
